var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1491_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 16C8.95913 16 9.78507 15.4207 10.1475 14.5938H5.85254C6.21495 15.4207 7.04091 16 8.00001 16Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 7.74569V6.71875C12.8438 4.53681 11.3934 2.68747 9.40629 2.08344V1.40625C9.40629 0.630844 8.77544 0 8.00004 0C7.22463 0 6.59379 0.630844 6.59379 1.40625V2.08344C4.6066 2.68747 3.15629 4.53678 3.15629 6.71875V7.74569C3.15629 9.66231 2.42572 11.4797 1.09919 12.8631C0.969193 12.9986 0.932661 13.1987 1.00635 13.3714C1.08004 13.5442 1.24972 13.6562 1.43754 13.6562H14.5625C14.7503 13.6562 14.92 13.5442 14.9937 13.3714C15.0674 13.1987 15.0308 12.9986 14.9009 12.8631C13.5743 11.4797 12.8438 9.66228 12.8438 7.74569ZM8.46879 1.89775C8.31451 1.88288 8.15816 1.875 8.00004 1.875C7.84191 1.875 7.68557 1.88288 7.53129 1.89775V1.40625C7.53129 1.14778 7.74157 0.9375 8.00004 0.9375C8.25851 0.9375 8.46879 1.14778 8.46879 1.40625V1.89775Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.094 6.71853C14.094 6.97741 14.3039 7.18728 14.5627 7.18728C14.8216 7.18728 15.0315 6.97741 15.0315 6.71853C15.0315 4.84041 14.3001 3.07469 12.9721 1.74666C12.789 1.56363 12.4922 1.5636 12.3092 1.74666C12.1261 1.92972 12.1261 2.2265 12.3092 2.40957C13.4601 3.56054 14.094 5.09082 14.094 6.71853Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 7.18727C1.69638 7.18727 1.90625 6.97739 1.90625 6.71852C1.90625 5.09083 2.54012 3.56055 3.69106 2.40958C3.87412 2.22652 3.87412 1.92973 3.69106 1.74667C3.50803 1.56361 3.21122 1.56361 3.02816 1.74667C1.70012 3.0747 0.96875 4.84039 0.96875 6.71852C0.96875 6.97739 1.17862 7.18727 1.4375 7.18727Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification .5a929d320972d537be6909ee18da9188.svg";
export { ForwardRef as ReactComponent };